export default "/react/logoGossip-16a20173.png";